import React from 'react'
import Orders from './Orders/Orders'
import Rents from './Rents/Rents'
import Tab from '../../components/UI/OrderTabbedPanel/TabbedPanel'
import { Grid } from '@material-ui/core'

const OrdersList = (props) => {
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))
    const tabs = permission != null && (permission.includes('ORDER_READ') && permission.includes('RENT_READ')) ?
        [
            {
                index: 0,
                label: "سفارشات",
                value: <Orders />
            },
            {
                index: 1,
                label: "سفارشات اجاره ای",
                value: <Rents />
            }
        ] :
        (
            permission != null && permission.includes('ORDER_READ') ?
                [
                    {
                        index: 0,
                        label: "سفارشات",
                        value: <Orders />
                    }
                ] :
                [
                    {
                        index: 1,
                        label: "سفارشات اجاره ای",
                        value: <Rents />
                    }
                ]
        )

    return (
        <div className='row justify-content-center'>
            <Grid lg={11} xs={11}>
                <Tab tabs={tabs} />
            </Grid>
        </div>
    )
}

export default OrdersList